import * as AvatarPrimitive from "@radix-ui/react-avatar"
import type { ComponentProps } from "react"

import { getProxiedImageUrl } from "~/lib/proxy-url"
import { cn } from "~/lib/utils"

function Avatar({
	className,
	...props
}: ComponentProps<typeof AvatarPrimitive.Root>) {
	return (
		<AvatarPrimitive.Root
			data-slot="avatar"
			className={cn(
				"relative flex size-8 shrink-0 overflow-hidden rounded-full",
				className
			)}
			{...props}
		/>
	)
}

function AvatarImage({
	className,
	src,
	...props
}: Omit<ComponentProps<typeof AvatarPrimitive.Image>, "src"> & {
	src?: string | null
}) {
	return (
		<AvatarPrimitive.Image
			data-slot="avatar-image"
			className={cn("aspect-square size-full", className)}
			src={getProxiedImageUrl(src)}
			{...props}
		/>
	)
}

function AvatarFallback({
	className,
	background = true,
	...props
}: ComponentProps<typeof AvatarPrimitive.Fallback> & { background?: boolean }) {
	return (
		<AvatarPrimitive.Fallback
			data-slot="avatar-fallback"
			className={cn(
				"flex size-full items-center justify-center rounded-full text-text-small",
				background && "bg-active",
				className
			)}
			{...props}
		/>
	)
}

export { Avatar, AvatarFallback, AvatarImage }
